import PropTypes from "prop-types";

export const BarChart = ({ chartData, highestCount, color }) => {
  const chartHeight = 11;
  const scale = 25;

  const precision = Math.ceil(highestCount?.count / (chartHeight - 1));

  return (
    <div className="bg-white border-[2px] pl-10 pt-7 pb-5 pr-7 w-full">
      <table className="w-full">
        <tbody>
          {[...Array(chartHeight)].map((value, index) => {
            const score = (chartHeight - 1 - index) * precision;
            return (
              <tr key={index} className="w-full">
                <td className="relative w-[0%]">
                  <div className="absolute text-sm top-[-10px] left-[-27px]">
                    {score ? score : null}
                  </div>
                </td>
                {chartData.map((obj, index1) => {
                  const barHeight =
                    (obj.count / (precision * (chartHeight - 1))) *
                    ((chartHeight - 1) * scale);
                  return (
                    <td
                      key={index1}
                      className={`relative ${
                        index + 1 === chartHeight ? "" : "border"
                      } w-1/12`}
                      style={{ height: `${scale}px` }}
                    >
                      {index + 1 === chartHeight - 1 && barHeight ? (
                        <div className="">
                          <div
                            className={`absolute left-[30%] bottom-0 w-2/5 ${color}`}
                            style={{ height: `${barHeight}px` }}
                          >
                            <span className="absolute top-[-23px] text-sm">
                              {obj?.count}
                            </span>
                          </div>
                        </div>
                      ) : null}
                      {index + 1 === chartHeight && barHeight ? (
                        <div className="text-sm">
                          <div className="text-center">{obj?.month}</div>
                          <div className="text-center">
                            {obj?.year.toString().slice(-2)}
                          </div>
                        </div>
                      ) : null}
                    </td>
                  );
                })}
                {[...Array(12 - chartData.length)].map((value2, index2) => {
                  return (
                    <td
                      key={index2}
                      className={`relative ${
                        index + 1 === chartHeight ? "" : "border"
                      } w-1/12`}
                      style={{ height: `${scale}px` }}
                    ></td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

BarChart.propTypes = {
  chartData: PropTypes.array.isRequired,
  highestCount: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
};
